(() => {
  // js/base/accordion-menu.js
  document.addEventListener("DOMContentLoaded", () => {
    const accordionMenus = document.querySelectorAll("[data-accordion-menu]");
    accordionMenus.forEach((accordionMenu) => {
      accordionMenu.querySelectorAll("[data-has-sub-menu]>*").forEach((menuLink) => {
        menuLink.addEventListener("click", (event) => {
          console.log("click");
          event.preventDefault();
          const parentItem = menuLink.parentElement;
          const isExpanded = parentItem.getAttribute("aria-expanded") === "true";
          parentItem.setAttribute("aria-expanded", isExpanded ? "false" : "true");
        });
      });
    });
  });

  // js/base/dialog.js
  document.querySelectorAll("dialog").forEach((dialog) => {
    const body = document.body;
    const defaultShowModal = dialog.showModal;
    dialog.showModal = () => {
      defaultShowModal.call(dialog);
      dialog.dataset.dialogState = "open";
      body.dataset.dialogState = "open";
      dialog.dispatchEvent(new CustomEvent("open"));
    };
    const defaultClose = dialog.close;
    dialog.close = () => {
      dialog.addEventListener("animationend", () => defaultClose.call(dialog), {
        once: true
      });
      dialog.dataset.dialogState = "close";
      body.dataset.dialogState = "close";
    };
    dialog.addEventListener("click", (e) => {
      const rect = e.target.getBoundingClientRect();
      if (rect.left > e.clientX || rect.right < e.clientX || rect.top > e.clientY || rect.bottom < e.clientY) {
        dialog.close();
      }
      e.stopPropagation();
    });
  });
  document.querySelectorAll("[data-open-dialog]").forEach((btn) => {
    const dialog = document.querySelector(btn.dataset.openDialog);
    btn.addEventListener("click", (e) => {
      dialog.showModal();
      e.stopPropagation();
      e.preventDefault();
    });
  });
  document.querySelectorAll("[data-close-dialog]").forEach((btn) => {
    let dialog = document.querySelector(btn.dataset.openDialog);
    if (!dialog) dialog = btn.closest("dialog");
    btn.addEventListener("click", (e) => {
      dialog.close();
      e.stopPropagation();
      e.preventDefault();
    });
  });

  // js/base/intersection.js
  document.addEventListener("DOMContentLoaded", () => {
    const observerOptions = {
      root: null,
      // ビューポートをルート要素にする
      rootMargin: "0px",
      // マージンなし
      threshold: 0.1
      // 10%以上表示されたら
    };
    const observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        entry.target.dataset.intersectionState = entry.isIntersecting;
        entry.target.dispatchEvent(new CustomEvent("intersection"));
        if (entry.isIntersecting && void 0 == entry.target.dataset.intersectionRepeat) {
          observer2.unobserve(entry.target);
        }
      });
    }, observerOptions);
    document.querySelectorAll("[data-intersection]").forEach((element) => {
      observer.observe(element);
    });
  });
})();
